import classnames from 'classnames';
import './ChevronIcon.css';

export enum ChevronDirection {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
}

interface ChevronIconProps {
  /**
   * Direction the chevron should point
   * @default ChevronDirection.DOWN
   */
  direction?: ChevronDirection;
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Size of the icon in pixels
   * @default 16
   */
  size?: number;
}

function ChevronIcon({ direction = ChevronDirection.DOWN, className, size = 16 }: ChevronIconProps) {
  const chevronClasses = classnames('chevron-icon', className, {
    'chevron-icon--down': direction === ChevronDirection.DOWN,
    'chevron-icon--left': direction === ChevronDirection.LEFT,
    'chevron-icon--right': direction === ChevronDirection.RIGHT,
    'chevron-icon--up': direction === ChevronDirection.UP,
  });

  return (
    <svg
      aria-hidden='true'
      className={chevronClasses}
      fill='none'
      focusable='false'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
      style={{ height: `${size}px`, width: `${size}px` }}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'>
      <polyline points='2,5 8,11 14,5' />
    </svg>
  );
}

export default ChevronIcon;
